// import { columnsDataColumns } from "./variables/columnsData";
import ProductsTable from "./components/Products_table";
import GlobaleTable from "./components/Generale_table";
import TCPTable from "./components/Tcps_table";

import { getCookie } from "utils/cookies";
import { getOneOperatorApi } from "api/operator";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Spinner } from "@material-tailwind/react";

const Dashboard = () => {
  const { userID } = useParams();
  const [accessList, setAccessList] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    getAccessList();
  }, []);

  const getAccessList = async () => {
    try {
      setIsLoading(true);

      const id = getCookie("3F2Mb2pJ1YRro5Z4");
      const adminRole = getCookie("lv9u765qzk1gr4fn1e");

      if (adminRole === "FALSE") {
        const response = await getOneOperatorApi(id);
        const accessList = response.userFromRole.access;

        const selectedAccessDetails = accessList.find(
          (el) => el.value._id == userID
        );

        const accessObject = {
          Add: false,
          Read: false,
          Update: false,
          Delete: false,
          TABLE_DES_PRODUITS: false,
          TABLE_TCP: false,
          TABLE_GENERALE: false,
          pdf_excel: false
        };

        selectedAccessDetails.sectionItems.map((el) => {
          if (el.value == "Add" && el.checked) {
            accessObject.Add = true;
          }
          if (el.value == "Read" && el.checked) {
            accessObject.Read = true;
          }
          if (el.value == "Update" && el.checked) {
            accessObject.Update = true;
          }
          if (el.value == "Delete" && el.checked) {
            accessObject.Delete = true;
          }

          if (el.value == "TABLE_DES_PRODUITS" && el.checked) {
            accessObject.TABLE_DES_PRODUITS = true;
          }
          if (el.value == "TABLE_TCP" && el.checked) {
            accessObject.TABLE_TCP = true;
          }
          if (el.value == "TABLE_GENERALE" && el.checked) {
            accessObject.TABLE_GENERALE = true;
          }
          if (el.value == "pdf_excel" && el.checked) {
            accessObject.pdf_excel = true;
          }
        });

        setAccessList({
          Add: accessObject.Add,
          Read: accessObject.Read,
          Update: accessObject.Update,
          Delete: accessObject.Delete,
          TABLE_DES_PRODUITS: accessObject.TABLE_DES_PRODUITS,
          TABLE_TCP: accessObject.TABLE_TCP,
          TABLE_GENERALE: accessObject.TABLE_GENERALE,
          pdf_excel: accessObject.pdf_excel,
        });
      } else if (adminRole === "TRUE") {
        setAccessList({
          Add: true,
          Read: true,
          Update: true,
          Delete: true,
          TABLE_DES_PRODUITS: true,
          TABLE_TCP: true,
          TABLE_GENERALE: true,
          pdf_excel: true
        });
      }
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      {isLoading ? (
        <div className="flex items-center justify-center">
          <Spinner className="h-12 w-12" />
        </div>
      ) : (
        <>
          <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
            {accessList.TABLE_DES_PRODUITS ? (
              <ProductsTable accessList={accessList} />
            ) : (
              <></>
            )}
          </div>
          <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
            {accessList.TABLE_TCP ? (
              <TCPTable accessList={accessList} />
            ) : (
              <></>
            )}
          </div>
          <div className="mt-5 grid h-full grid-cols-1 gap-5 md:grid-cols-1">
            {accessList.TABLE_GENERALE ? (
              <GlobaleTable accessList={accessList} />
            ) : (
              <></>
            )}
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
